import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './destination.start-many.reducer';
import {Destination} from '../../../services/api/destinations/destination.model';

export const startManyDestinationsFeatureKey = 'startManyDestinations';
export const featureSelector = createFeatureSelector<State>(startManyDestinationsFeatureKey);

export const getStartManyDestinationsRecord = createSelector(
  featureSelector,
  (state: State): Destination[] => state.record
);

export const getStartManyDestinationsLoaded = createSelector(
  featureSelector,
  (state: State): boolean => state.loaded
);

export const getStartManyDestinationsLoading = createSelector(
  featureSelector,
  (state: State): boolean => state.loading
);

export const getStartManyDestinationsError = createSelector(
  featureSelector,
  (state: State): any => state.error
);
